export default "__VITE_ASSET__f26bfc4e__"